import { createChildListModalContainer } from 'factories/ChildListModal'
import actions from 'actions/orders/orderItems'
import Component from 'components/Issue/FormView/ValidateStatus'

export default createChildListModalContainer({ actions })(Component)
